export default {
  blogList: state => state.blogList.sort((a, b) => a.freeze_date < b.freeze_date),
  blogData: state => state.blogData,
  blogListLoading: state => state.blogListLoading,
  blogDataLoading: state => state.blogDataLoading,
};
